import React from "react";
import styled from "styled-components";
import laborFeeHtml from "../../assets/html/settlement_price_by_car.html";

const LaborFee: React.FC = () => {
  return (
    <LaborFeeFrame
      srcDoc={laborFeeHtml}
      title="차량 정산가 조회"
      sandbox="allow-scripts"
    />
  );
};

export default LaborFee;

const LaborFeeFrame = styled.iframe`
  display: block;
  width: 100%;
  height: calc(100vh - 180px);
  min-height: 640px;
  border: 0;
  border-radius: 12px;
  background: #f4f5f7;
`;
